export default function Footer() {
  return (
    <footer className="h-full bg-[#F8F8F8] py-3 md:py-[47px] px-4 md:px-[53px]">
      <h2 className=" font-nunito">
        How to use the eWaiver solution ?
      </h2>

      <hr className="bg-[#84BD00] h-[2px] w-16" />

      <p className="mt-[26px]">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
        commodo consequat. <br /> <br />
        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
        dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
        proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
      </p>
    </footer>
  );
}
